import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const JsonContents = ({ obj, callbackFromParent }) => {
    // state
    const [objJson, setObjJson] = useState('');
    const [isDf, setIsDf] = useState(true);

    // DialogFlow
    const dfValue = {
        type: 'kakao',
        data: obj,
    };

    // 웹챗봇
    const trValue = {
        type: 'turingbot',
        data: obj,
    };

    // obj > json text
    let jsonTxt = JSON.stringify(obj, undefined, 4);
    let dfJsonTxt = JSON.stringify(dfValue, undefined, 4);
    let trJsonTxt = JSON.stringify(trValue, undefined, 4);

    useEffect(() => {
        setObjJson(jsonTxt);
    }, [jsonTxt]);

    // textarea event
    const onChangeValue = (e) => {
        setObjJson(e.target.value);
        let jsonObj = JSON.parse(e.target.value);
        // DialogFlow
        // if (isDf) {
        //     jsonObj = jsonObj.data;
        // }
        // data만 가져옴
        jsonObj = jsonObj.data;
        // 해당 프로퍼티 없을 때
        if (!jsonObj || !jsonObj.template || !jsonObj.template.outputs) {
            // 기존 props로 변경
            jsonObj = obj;
            setObjJson(obj);
        }
        // 부모 전달
        callbackFromParent(jsonObj);
    };

    // tab toggle
    const handleToggleJson = () => {
        setIsDf(!isDf);
    };

    // textarea copy
    const textAreaRef = useRef();
    const copyJson = (e) => {
        textAreaRef.current.select();
        document.execCommand('copy');
        e.target.focus();
        window.getSelection().removeAllRanges();
        alert('복사되었습니다.');

        // let copyText = document.createElement('textarea');
        // copyText.className = 'copy-text-textarea';
        // document.body.appendChild(copyText);
        // copyText.value = textAreaRef.current.textContent.replace(/\s+/g, '');
        // copyText.select();
        // document.execCommand('copy');
        // document.body.removeChild(copyText);
        // e.target.focus();
        // alert('복사되었습니다.');
    };

    return (
        <div className="right-content">
            {/* tab title */}
            <div className="json-tab-title">
                <button
                    type="button"
                    className={`df ${isDf ? 'on' : ''}`}
                    onClick={handleToggleJson}
                >
                    카카오톡
                </button>
                <button
                    type="button"
                    className={`json ${!isDf ? 'on' : ''}`}
                    onClick={handleToggleJson}
                >
                    웹챗봇
                </button>
            </div>
            {/* tab cont */}
            <div className="json-tab-contents">
                <textarea
                    ref={textAreaRef}
                    className={`${isDf ? 'df' : 'json'}`}
                    spellCheck="false"
                    value={isDf ? dfJsonTxt : trJsonTxt}
                    onChange={onChangeValue}
                />
                <button type="button" onClick={copyJson}>
                    복사하기
                </button>
            </div>
        </div>
    );
};

JsonContents.propTypes = {
    obj: PropTypes.object,
    callbackFromParent: PropTypes.func,
};

JsonContents.defaultProps = {
    // bla: 'test',
};

export default JsonContents;
